import React, { useState, useEffect } from "react";
import { Button } from "../../../shadcn/components/ui/button";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { useSelector } from "react-redux";
import { bidInterest, requestContactDetail } from "services";
interface PDContactAuthorizedOfficerProps {
  propertyData: any;
  setAuthModelOpen: any;
  setAcknowledgementOpen: any;
  setAcknowledgementDetails: any;
  propertyType?: string;
}

export default function PDContactAuthorizedOfficer({
  propertyData,
  setAuthModelOpen,
  setAcknowledgementOpen,
  setAcknowledgementDetails,
  propertyType = "auction_property",
}: PDContactAuthorizedOfficerProps) {
  const { user } = useSelector((state: any) => state.auth);
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });
  const mobileNumber =
    user?.attributes?.find((number: any) => number?.type === "mobile_number")
      ?.value || "";
  const processedNumber = mobileNumber.startsWith("+91")
    ? mobileNumber.slice(3)
    : "";
  const form = useBetaForm({
    name: onboardingData?.name || "",
    mobile: processedNumber,
    email:
      user?.attributes?.find((number: any) => number?.type === "email")
        ?.value || "",
  });

  const mobileNumberRegEx: RegExp = /^[0-9]{10}$/;

  const form_constraints = {
    name: {
      presence: {
        allowEmpty: false,
      },
    },

    mobile: {
      presence: {
        allowEmpty: false,
      },
      format: {
        pattern: mobileNumberRegEx,
        message: "^Mobile number is not valid.",
      },
      length: {
        maximum: 10,
        message: "^Mobile number is too long (maximum is 10 characters)",
      },
    },
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const userToken = useSelector((state: any) => state.auth.accessToken);
  const [issSubmitted, setIsSubmitted] = useState(false);
  const clearForm = () => {
    form.setField("name", "");
    form.setField("mobile", "");
    form.setField("email", "");
  };

  const handleSubmit = async () => {
    if (userToken) {
      if (form.validate()) {
        form.value.email = form.value.email?.trim()?.toLowerCase();

        setIsSubmitted(true);
        setAcknowledgementDetails({
          name: form.getField("name"),
          mobile: form.getField("mobile"),
          email: form.getField("email"),
          isFooter: false,
        });
        let payload: any = {
          property_id: propertyData.listing_id ? propertyData.listing_id : "",
        };
        let mobile = form.getField("mobile");
        if (mobile.match(+91)) {
          payload["mobile_number"] = mobile;
        } else {
          payload["mobile_number"] = `+91${mobile}`;
        }
        payload["email"] = form.getField("email");
        payload["name"] = form.getField("name");
        payload["property_type"] = propertyType;
        try {
          await bidInterest(payload);
          let contactDetailPayload: any = {
            property_uuid: propertyData.uuid,
          };
          contactDetailPayload["name"] = form.getField("name");
          contactDetailPayload["email"] = form.getField("email");
          contactDetailPayload["mobile"] = payload["mobile_number"];
          await requestContactDetail(contactDetailPayload);
          // clearForm();
        } catch (error) {
          console.log("error: ", error);
        }

        setAcknowledgementOpen(true);
        setIsSubmitted(false);
      }
    } else {
      setAuthModelOpen(true);
    }
  };
  return (
    <div
      id="px-12234"
      className="mt-14 lg:mt-10 bg-brand-lightPink py-8 px-6 clip-path-mobileClipPolygonTopRight"
    >
      <h3 className="text-xl font-openSans font-semibold mb-4 lg:mb-5">
        Contact authorized officer
      </h3>

      <div className="p-4 mt-6 flex flex-col gap-6 bg-white">
        <h4>Please share your contact</h4>
        <div>
          <label className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack pt-6">
            NAME
          </label>
          <input
            type="text"
            placeholder="Enter name"
            value={form.getField("name")}
            onChange={(e) => form.setField("name", e.target.value)}
            className="border-none  h-10 mt-2 p-2 w-full font-openSans font-normal text-web-body-sm leading-4 text-[#A1A0A0] bg-brand-bgLightGrey"
          />
          {form.errors.get("name") ? (
            <p className="mt-2 text-sm text-red-500">
              {form.errors.get("name")[0] === "AttributeNotRegistered"
                ? "User not registered"
                : form.errors.get("name")[0]}
            </p>
          ) : null}
        </div>
        <div>
          <label className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack">
            MOBILE NUMBER
          </label>
          <input
            type="number"
            placeholder="Enter number"
            value={form.getField("mobile")}
            onChange={(e) => form.setField("mobile", e.target.value)}
            className="  border-none  h-10 mt-2 p-2  w-full font-openSans font-normal text-web-body-sm leading-4 text-[#A1A0A0] bg-brand-bgLightGrey"
          />
          {form.errors.get("mobile") ? (
            <p className="mt-2 text-sm text-red-500">
              {form.errors.get("mobile")[0] === "AttributeNotRegistered"
                ? "User not registered"
                : form.errors.get("mobile")[0]}
            </p>
          ) : null}
        </div>
        <div>
          <label className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack">
            EMAIL
          </label>
          <input
            type="email"
            placeholder="Enter email"
            value={form.getField("email")}
            onChange={(e) => form.setField("email", e.target.value)}
            className="border-none mt-2 h-10  p-2  w-full font-openSans font-normal text-web-body-sm leading-4 text-[#A1A0A0] bg-brand-bgLightGrey"
          />
          {form.errors.get("email") ? (
            <p className="mt-2 text-sm text-red-500">
              {form.errors.get("email")[0] === "AttributeNotRegistered"
                ? "User not registered"
                : form.errors.get("email")[0]}
            </p>
          ) : null}
        </div>
        <div className="w-full">
          <Button
            className="w-9/12"
            onClick={handleSubmit}
            disabled={issSubmitted}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
}
